import axios from "axios";
import React, { useState,useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";


const BASE_URL = "https://sutmmgdev.codydeasoftech.in/api";

const IssueJobWork = () => {
  const [showModal, setShowModal] = useState(false);
  const [items, setItems] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [itemId, setItemId] = useState("");
  const [sizeId, setSizeId] = useState("");
  const [fabricList, setFabricList] = useState([]);
  const [actionList, setActionList] = useState([]);
  const [selectedActions, setSelectedActions] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [issueToList, setIssueToList] = useState([]);
    const [measurements, setMeasurements] = useState([]);
    const [loadingMeasurements, setLoadingMeasurements] = useState(false);
const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
      const [totalRecords, setTotalRecords] = useState(0);
      const [totalPages, setTotalPages] = useState(1);
const [selectedVendorType, setSelectedVendorType] = useState("");
    const [loading, setLoading] = useState(false);
const [showDetailsModal, setShowDetailsModal] = useState(false);

const handleOpenDetailsModal = () => setShowDetailsModal(true);
const handleCloseDetailModal = () => setShowDetailsModal(false);

const orderedActions = actionList
  .filter(action =>
    Number(action.is_show_on_issue) === 1 &&
    Number(action.id) !== 2                     
  )
  .sort((a, b) => a.ordering - b.ordering);


const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);
  if (isNaN(d)) return "-";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`; // DD/MM/YYYY
};
const emptyItemBlock = {
  fabric_type: "",
  item_id: "",
  measurements: [],
  loading: false,
};

const [itemBlocks, setItemBlocks] = useState([emptyItemBlock]);


const fetchFabricList = async (itemId) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/fabricList`,
      { item_id: itemId },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    if (res.data?.status) {
      setFabricList(res.data.data.fabricList || []);
    } else {
      setFabricList([]);
    }
  } catch (err) {
    console.log("Fabric API Error:", err);
    if (handle401(err)) return;
  }
};






const handleAddMoreItem = () => {
  setItemBlocks((prev) => [...prev, emptyItemBlock]);
};
const today = new Date().toISOString().split("T")[0]; // "YY
  const [issues, setIssues] = useState([]);

  const [formData, setFormData] = useState({
    issue_date: today,
    item: "",
    size: "",
    qty: "",
    issue_to: "",
    beneficiary_id: "",
    tentative_return_date: "",
  });




     /* ================= FETCH ITEMS ================= */
const fetchItems = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(`${BASE_URL}/itemsList`,{} ,{
      headers: { Authorization: `Bearer ${token}` },
    });

    setItems(res.data?.data.itemsList || []);
  } catch (error) {
    console.error("Items API Error:", error);
            if (handle401(error)) return;

    Swal.fire(
      "Error",
      error?.response?.data?.message || "Failed to load items",
      "error"
    );
  }
};

const fetchActionList = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.get(
      `${BASE_URL}/jobWorkTypeList`,

      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const rawList = res.data?.data.jobWorkTypeList || [];

    setActionList(rawList);
  } catch (error) {
    console.error("Action list error", error);
                if (handle401(error)) return;

    Swal.fire(
      "Error",
      error?.response?.data?.message || "Failed to load action list",
      "error"
    );
  }
};


const fetchMeasurementsByItem = async (itemId, fabricId, index) => {
  // Get the current block
  const block = itemBlocks[index];

  if (!itemId || !fabricId) return;

  try {
    const token = localStorage.getItem("token");

    // show loading
    setItemBlocks((prev) =>
      prev.map((b, i) => (i === index ? { ...b, loading: true } : b))
    );

    const res = await axios.post(
      `${BASE_URL}/getItemWiseFabricRequirement`,
      { item_id: itemId, fabric_id: fabricId }, // ✅ new payload
      { headers: { Authorization: `Bearer ${token}` } }
    );

    // Store the overView array from API
    setItemBlocks((prev) =>
      prev.map((b, i) =>
        i === index
          ? { ...b, measurements: res.data?.data?.overView || [], loading: false }
          : b
      )
    );
  } catch (error) {
    if (handle401(error)) return;

    Swal.fire("Error", "Failed to load measurements", "error");
    setItemBlocks((prev) =>
      prev.map((b, i) => (i === index ? { ...b, loading: false } : b))
    );
  }
};





const fetchVendorType = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/vendorTypesList`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );

    console.log("Vendor Types:", res.data?.data);
    setIssueToList(res.data?.data || []);
  } catch (error) {
                if (handle401(error)) return;

    console.error("Vendor type fetch error", error);
    Swal.fire("Error", "Failed to load vendor types", "error");
  }
};

const fetchVendorsByType = async (vendorTypeId) => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/vendorsList`,
      { vendor_type_id: Number(vendorTypeId) },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    console.log("Vendors:", res.data?.data); // debug
    setVendorList(res.data?.data || []);
  } catch (error) {
                if (handle401(error)) return;

    console.error("Vendor fetch error", error);
    Swal.fire("Error", "Failed to load vendor list", "error");
  }
};

const fetchFabricStock = async (fabricId, index) => {
    console.log("Fabric stock api fired");
  try {
    const res = await axios.post(
      `${BASE_URL}/getFabricWiseCurrentStock`,
      { fabric_id: fabricId },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    if (res.data?.status) {
      const qty =
        res.data.data?.current_stock?.current_quantity || "0";

      // ✅ store stock per block
      setItemBlocks((prev) =>
        prev.map((b, i) =>
          i === index
            ? { ...b, stock_qty: qty }
            : b
        )
      );
    }
  } catch (err) {
    console.log("Stock API Error:", err);
    if (handle401(err)) return;
  }
};

  useEffect(() => {
      fetchVendorType();
    }, []);

  const openAddModal = () => {
    setFormData({
      issue_date: today,
      item: "",
      size: "",
      qty: "",
      issue_to: "",
      beneficiary_id: "",
      tentative_return_date: "",
    });
    fetchActionList();
    setShowModal(true);
      fetchItems();

  };

  // 🔹 Reset everything for modal
const resetModal = () => {
  setFormData({
    issue_date: "",
    item: "",
    size: "",
    qty: "",
    issue_to: "",
    vendor_id: "",
    beneficiary_id: "",
    tentative_return_date: "",
  });
  setItemBlocks([emptyItemBlock]); // reset to 1 empty block
  setSelectedActions([]);
  setVendorList([]);
};

const handleCloseModal = () => {
  resetModal();       // ✅ Reset all fields
  setShowModal(false);
};


const handleActionChange = (actionId) => {
  setSelectedActions(prev => {
    const actionIndex = orderedActions.findIndex(a => a.id === actionId);

    if (prev.includes(actionId)) {
      // Uncheck this action and all actions after it
      return prev.filter(id => {
        const idx = orderedActions.findIndex(a => a.id === id);
        return idx < actionIndex;
      });
    }

    // Only allow selecting the next sequential action
    if (prev.length === actionIndex) {
      return [...prev, actionId];
    }

    return prev; // ignore out-of-order clicks
  });
};



const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

// const handleSave = async () => {
//   // 🔴 Basic validation
//   if (
//     !formData.issue_date ||
//     !formData.issue_to ||
//     !formData.vendor_id ||
//     selectedActions.length === 0 ||
//     itemBlocks.some(b => !b.item_id || !b.fabric_type) ||
//     !formData.tentative_return_date
//   ) {
//     Swal.fire("Error", "Please fill all required fields", "error");
//     return;
//   }

//   const payload = {
//     issue_date: formData.issue_date,
//     vendor_type: formData.issue_to,
//     vendor: formData.vendor_id,
//     jobs: selectedActions,
//     items: itemBlocks.map(b => Number(b.item_id)),
//     fabrics: itemBlocks.map(b => Number(b.fabric_type)),
//     date_of_start_returning: formData.tentative_return_date,
//   };

//   try {
//     const token = localStorage.getItem("token");

//     const res = await axios.post(
//       `${BASE_URL}/issueJobWorks`,
//       payload,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     if (res.data?.status) {
//         Swal.fire("Success", res.data.message, "success");

//       // ✅ close & reset
//       handleCloseModal();
//       await issuedJobWorksList();
//     } else {
//       Swal.fire("Error", res.data?.message || "Failed to issue job", "error");
//     }
//   } catch (error) {
//     if (handle401(error)) return;

//     Swal.fire(
//       "Error",
//       error?.response?.data?.message || "Something went wrong",
//       "error"
//     );
//   }
// };


const handleSave = async () => {
  // Basic validation
  if (
    !formData.issue_date ||
    !formData.issue_to ||
    !formData.vendor_id ||
    selectedActions.length === 0 ||
    itemBlocks.some(b => !b.item_id || !b.fabric_type) ||
    !formData.tentative_return_date
  ) {
    Swal.fire("Error", "Please fill all required fields", "error");
    return;
  }

  const payload = {
    issue_date: formData.issue_date,
    vendor_type: formData.issue_to,
    vendor: formData.vendor_id,
    jobs: selectedActions,
    items: itemBlocks.map(b => Number(b.item_id)),
    fabrics: itemBlocks.map(b => Number(b.fabric_type)),
    date_of_start_returning: formData.tentative_return_date,
  };

  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(`${BASE_URL}/issueJobWorks`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.data?.status) {
      Swal.fire("Success", res.data.message, "success");

      await issuedJobWorksList({
        page: 1,
        vendorTypeId: formData.issue_to,
        vendorId: formData.vendor_id,
        jobWorkIds: selectedActions,
      });

      handleCloseModal();
    } else {
      Swal.fire("Error", res.data?.message || "Failed to issue job", "error");
    }
  } catch (error) {
    if (handle401(error)) return;

    Swal.fire(
      "Error",
      error?.response?.data?.message || "Something went wrong",
      "error"
    );
  }
};



// const issuedJobWorksList = async(page = 1) => {
//   try {
//     const token = localStorage.getItem("token");

//     const res = await axios.post(
//       `${BASE_URL}/getIssuedJobWorksList`,
//       {
//         vendor_type_id: selectedVendorType || "", // from dropdown
//         vendor_id: formData.vendor_id || "",      // from vendor select
//         job_work_type_id: selectedActions.join(",") || "", // if multiple jobs selected
//         page: page,
//         per_page: perPage
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     if (res.data?.status) {
//       setIssues(res.data.data);
//       setTotalRecords(res.data.total_records || 0);
//       setTotalPages(Math.ceil((res.data.total_records || 0) / perPage));
//       setPage(page);
//     }
//   } catch (err) {
//     if (handle401(err)) return;
//     console.error("Issued Job Works List Error:", err);
//   }
// };



const issuedJobWorksList = async ({
  page = 1,
  vendorTypeId = selectedVendorType,
  vendorId = formData.vendor_id,      // ⚠️ use filter vendor, not modal
  jobWorkIds = selectedActions,
} = {}) => {
  try {
    setLoading(true);

    const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/getIssuedJobWorksList`,
      {
        vendor_type_id: vendorTypeId || "",
        vendor_id: vendorId || "",
        job_work_type_id: jobWorkIds.length ? jobWorkIds.join(",") : "",
        page,
        per_page: perPage,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (res.data?.status) {
      setIssues(res.data.data || []);
      setTotalRecords(res.data.total_records || 0);
      setTotalPages(Math.ceil((res.data.total_records || 0) / perPage));
      setPage(page);
    } else {
      setIssues([]);
      setTotalRecords(0);
      setTotalPages(1);
    }
  } catch (err) {
    if (handle401(err)) return;
    console.error("Issued Job Works List Error:", err);
    setIssues([]);
  } finally {
    setLoading(false);  // 🔥 always stop loader
  }
};



const theadStyle ={

                padding: "5px",
                fontWeight: "600",
                letterSpacing: "0.5px",
                borderTopLeftRadius: "10px",
                backgroundColor: "#edf7fe",
                height: "10px",
                borderBottom: "1px solid black",
                borderTop: "1px solid black",
                textAlign: "center",

}
useEffect(() => {
  issuedJobWorksList({ page: 1 });
}, [perPage]);
  return (
    <div className="container mt-4" style={{ maxWidth: 1300 }}>
      {/* HEADER */}
      <Card
              className="mb-4 border-0"
              style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
            >
              <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
                <h5 className="mb-0 fw-bold">
                  <i className="fa-solid fa-scissors"></i> Issue Job Work
                </h5>
              </div>

              <Card.Body className="px-4 py-4">
                <Row className="align-items-center">

                  <Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Vendor Type</Form.Label>
    <Form.Select
      value={selectedVendorType}
      onChange={(e) => {
        const vendorTypeId = e.target.value;

        setSelectedVendorType(vendorTypeId);  // track selected type
        setFormData({ ...formData, vendor_id: "" }); // reset vendor selection

        if (vendorTypeId) {
          fetchVendorsByType(vendorTypeId); // fetch vendors for this type
        } else {
          setVendorList([]); // clear if no type selected
        }
      }}
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
      }}
    >
      <option value="">Select Vendor type</option>
      {issueToList.map((v) => (
        <option key={v.id} value={v.id}>
          {v.vendor_type_short_name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>




<Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Vendor</Form.Label>
    <Form.Select
      value={formData.vendor_id || ""}
      onChange={(e) =>
        setFormData({ ...formData, vendor_id: e.target.value })
      }
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
      }}
      disabled={!selectedVendorType || vendorList.length === 0} // disable if no type selected
    >
      <option value="">Select Vendor</option>
      {vendorList.map((v) => (
        <option key={v.id} value={v.id}>
          {v.vendors_master_name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>


                  <Col md={3}>
                                             <Form.Group className="mb-3">
                                                             <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

                                                 <Form.Select
                                                  style={{
                                                                 borderRadius: "10px",
                                                                 border: "2px solid #1565C1",
                                                               }}
                                                   value={perPage}
                                                   onChange={(e) => {
                                                     const value = Number(e.target.value);
                                                     setPerPage(value);
                                                     setPage(1);

                                                   }}

                                                 >
                                                   <option value={10}>10 Per Page</option>
                                                         <option value={25}>25 Per Page</option>
                                                         <option value={50}>50 Per Page</option>
                                                         <option value={100}>100 Per Page</option>
                                                 </Form.Select>
                                                 </Form.Group>
                                             </Col>
                  <Col md={4} className="d-flex gap-3 mt-3">
                                            {/* SEARCH */}
                                            <Button
                                              className="w-50 fw-semibold text-white"
                                              style={{
                                                background: "#1565C1",
                                                border: "none",
                                                borderRadius: "10px",
                                                transition: "0.3s",
                                              }}
                                              onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                                              onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                                              onClick={() => issuedJobWorksList()}
                                            >
                                              <i className="fa-solid fa-magnifying-glass me-2"></i> Search

                                            </Button>

                                            {/* RESET */}
                                            <Button
  className="w-50 fw-semibold text-white"
  style={{
    background: "#E53935",
    border: "none",
    borderRadius: "10px",
    transition: "0.3s",
  }}
  onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
  onMouseLeave={(e) => (e.target.style.background = "#E53935")}
  onClick={() => {
    // Reset pagination
    setPage(1);
    setPerPage(10);

    // Clear filters
    setSelectedVendorType("");    // vendor type dropdown
    setFormData({
      ...formData,
      vendor_id: "",              // vendor dropdown
    });
    setSelectedActions([]);       // selected job works

    // Reset the list with default parameters
    issuedJobWorksList({
      page: 1,
      vendorTypeId: "",
      vendorId: "",
      jobWorkIds: [],
    });

    // Clear vendor list as vendor type is cleared
    setVendorList([]);
  }}
>
  <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
</Button>

                                          </Col>
                </Row>
              </Card.Body>
            </Card>

      {/* ADD BUTTON */}
      <Button
        className="mb-3 text-white"
        style={{
          background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
          borderRadius: "10px",
        }}
        onClick={openAddModal}
      >
        <i className="fa-solid fa-circle-plus me-2"></i> Issue Jobs
      </Button>

      {/* TABLE */}
      <Card className="border-0">
        <Table hover striped responsive>
          <thead>
            <tr className="text-center">
              <th style={theadStyle}>SL</th>
              <th style={theadStyle}>Issue Date</th>
              <th style={theadStyle}>Vendor Type</th>
              <th style={theadStyle}>Vendor</th>
              <th style={theadStyle}>Job Works</th>
              <th style={theadStyle}>Tentative Return</th>
              <th style={theadStyle}>Action</th>
            </tr>
          </thead>
          <tbody>
            {issues.length > 0 ? (
              issues.map((row, i) => (
                <tr key={i} className="text-center">
                   <td className="text-center">
          {(page - 1) * perPage + i + 1}
        </td>
                  <td>{formatDate(row.issue_date)}</td>
                  <td>{row.vendor_type_short_name}</td>
                  <td>{row.vendors_master_name}</td>
                  <td style={{width: "230px"}}>
                    {row.jobs?.map(j => j.action_name).join(", ") || "-"}
                  </td>

                  <td>{formatDate(row.date_of_start_returning)}</td>
                                    <td className="text-center">
  <Button
    size="sm"
    style={{
      background: "#FBC02D",
      color: "#000",
      border: "none",
      padding: "5px 12px",
      borderRadius: "6px",
      fontWeight: "600",
      boxShadow: "0 2px 6px rgba(251,192,45,0.5)",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.background = "#F9A825")}
    onMouseLeave={(e) => (e.currentTarget.style.background = "#FBC02D")}
  onClick={handleOpenDetailsModal}

  >
    Details
  </Button>
</td>


                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>

         {totalPages > 1 && (
      <div className="d-flex justify-content-center mt-4">
        <nav>
          <ul className="pagination shadow-sm">
            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => issuedJobWorksList(1)}>«</button>
            </li>

            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => issuedJobWorksList(page - 1)}>‹</button>
            </li>

            {getPageNumbers().map((p) => (
              <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                <button className="page-link" onClick={() => issuedJobWorksList(p)}>
                  {p}
                </button>
              </li>
            ))}

            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => issuedJobWorksList(page + 1)}>›</button>
            </li>

            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => issuedJobWorksList(totalPages)}>»</button>
            </li>
          </ul>
        </nav>
      </div>
    )}
      </Card>




     {/* DETAILS MODAL */}
     <Modal
        show={showDetailsModal}
        onHide={handleCloseDetailModal}
        size="xl"
        centered
        >
        <Modal.Header closeButton style={{ background: "#1565C1", color: "#fff" }}>
            <Modal.Title>Job Work Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <Table hover striped responsive>
            <thead>
                <tr>
                <th>SL</th>
                <th>Vendor</th>
                <th>Item</th>
                <th>Size</th>
                <th>Amount</th>
                <th>Balance</th>
                <th>Type</th>
                <th>Date</th>
                </tr>
            </thead>
            <tbody>
                {/* Use real data here */}
                {issues.length > 0 ? (
                issues.map((t, idx) => (
                    <tr key={idx} className="text-center">
                    <td>{idx + 1}</td>
                    <td>{t.vendors_master_name}</td>
                    <td>{t.item_name || "-"}</td>
                    <td>{t.size || "-"}</td>
                    <td>₹ {t.amount || 0}</td>
                    <td style={{ color: "green", fontWeight: 600 }}>
                        ₹ {t.current_amount || 0}
                    </td>
                    <td>{t.type || "-"}</td>
                    <td>{formatDate(t.created_at)}</td>
                    </tr>
                ))
                ) : (
                <tr>
                    <td colSpan="8" className="text-center">
                    No Data Found
                    </td>
                </tr>
                )}
            </tbody>
            </Table>
        </Modal.Body>

        <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseDetailModal}>
            Close
            </Button>
        </Modal.Footer>
     </Modal>

      {/* MODAL */}
      <Modal show={showModal} size="lg" onHide={handleCloseModal} centered>
        <Modal.Header closeButton style={{ background: "#3399ff", color: "#fff" }}>
          <Modal.Title>Issue Work</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Issue Date */}
          <Row>
           <Col md={4}>
            <Form.Group className="mb-2">
            <Form.Label>Issue Date <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="date"
              value={formData.issue_date}
              onChange={(e) =>
                setFormData({ ...formData, issue_date: e.target.value })
              }
            />
          </Form.Group>
           </Col>
<Col md={4}>
          {/* Issue To */}
          <Form.Group className="mb-2">
            <Form.Label>Select Vendor Type <span className="text-danger">*</span></Form.Label>
            <Form.Select
  value={formData.issue_to}
  onChange={(e) => {
    const value = e.target.value;

    setFormData({
      ...formData,
      issue_to: value,
      vendor_id: "",
      beneficiary_id: "",
    });

    setVendorList([]);

    if (value) {
      fetchVendorsByType(value); // 🔥 API CALL
    }
  }}
>
  <option value="">Select</option>

  {issueToList.map((i) => (
    <option key={i.id} value={i.id}>
      {i.vendor_type_short_name}
    </option>
  ))}
</Form.Select>


          </Form.Group>

</Col>
<Col md={4}>



          <Form.Group className="mb-2">
  <Form.Label>
   Select Vendor <span className="text-danger">*</span>
  </Form.Label>

  <Form.Select
    value={formData.vendor_id || ""}
    disabled={!formData.issue_to || vendorList.length === 0}
    onChange={(e) =>
      setFormData({
        ...formData,
        vendor_id: e.target.value,
      })
    }
  >
    <option value="">Select Vendor</option>

    {vendorList.map((v) => (
      <option key={v.id} value={v.id}>
        {v.vendors_master_name}
      </option>
    ))}
  </Form.Select>
</Form.Group>


          </Col>

          </Row>




<Form.Group className="mb-3">
  <Form.Label className="fw-bold">Select Jobs</Form.Label>
  <div style={{ maxHeight: "220px", overflowY: "auto", borderRadius: "8px", padding: "10px" }}>
    {orderedActions.length > 0 ? (
      <Row>
        {orderedActions.map((action) => {
          const actionIndex = orderedActions.findIndex(a => a.action_master_id === action.action_master_id);
          const isChecked = selectedActions.includes(action.id);

          // ✅ Only enable checkbox if it’s the next in sequence
          const isDisabled = !isChecked && selectedActions.length !== actionIndex;

          return (
            <Col md={4} key={action.action_master_id}>
              <Form.Check
  type="checkbox"
  id={`action-${action.id}`}
  label={action.action_name}
  checked={selectedActions.includes(action.id)}
  disabled={
    !selectedActions.includes(action.id) &&
    selectedActions.length !== orderedActions.findIndex(a => a.id === action.id)
  }
  onChange={() => handleActionChange(action.id)}
  className="mb-2"
/>

            </Col>
          );
        })}
      </Row>
    ) : (
      <div className="text-muted text-center">No Actions Found</div>
    )}
  </div>
</Form.Group>




{itemBlocks.map((block, index) => (
  <div
    key={index}
    className="mb-4 p-3 pt-5 position-relative"
    style={{
      border: "1px solid #D6E6FA",
      borderRadius: "10px",
      background: "#F9FBFF",
    }}
  >
    {/* CROSS BUTTON */}
    {itemBlocks.length > 1 && ( // only show if more than 1 block
      <Button
        size="sm"
        variant="danger"
        className="position-absolute top-0 end-0 m-2"
        style={{ borderRadius: "10%", padding: "0px 8px", fontWeight: "bold", fontSize: "20px" }}
        onClick={() =>
          setItemBlocks((prev) =>
            prev.filter((_, i) => i !== index)
          )
        }
      >
        &times;
      </Button>
    )}




    {/* MEASUREMENT TABLE */}


<Row className="mb-3">
  {/* ITEM */}
  <Col md={4}>
    <Form.Group>
      <Form.Label>
        Item <span className="text-danger">*</span>
      </Form.Label>
      <Form.Select
        value={block.item_id}
        onChange={(e) => {
          const itemId = e.target.value;

          setItemBlocks((prev) =>
            prev.map((b, i) =>
              i === index
                ? {
                    ...b,
                    item_id: itemId,
                    fabric_type: "",
                    measurements: [],
                    stock_qty: null,
                  }
                : b
            )
          );

          if (itemId) {
            fetchFabricList(itemId); // ✅ fetch fabrics
          } else {
            setFabricList([]);
          }
        }}
      >
        <option value="">Select Item</option>
        {items.map((i) => (
          <option key={i.id} value={i.id}>
            {i.item_name}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  </Col>

  {/* FABRIC */}
  <Col md={4}>
    <Form.Group>
      <Form.Label>
        Select Fabric <span className="text-danger">*</span>
      </Form.Label>
      <Form.Select
  value={block.fabric_type}
  disabled={!block.item_id}
  onChange={(e) => {
    const fabricId = e.target.value;
    const itemId = block.item_id;

    setItemBlocks(prev =>
      prev.map((b, i) =>
        i === index
          ? { ...b, fabric_type: fabricId, measurements: [], stock_qty: null }
          : b
      )
    );

    if (itemId && fabricId) {
      fetchFabricStock(fabricId, index);        // existing stock API
      fetchMeasurementsByItem(itemId, fabricId, index);
    }
  }}
>
  <option value="">Select Fabric</option>
  {fabricList.map(f => (
    <option key={f.id} value={f.id}>{f.name}</option>
  ))}
</Form.Select>


    </Form.Group>
  </Col>

  {/* STOCK */}
  {block.item_id && block.fabric_type && (
    <Col md={4} className="d-flex align-items-end">
  <Card
    className="w-100 border-0"
    style={{
      boxShadow: "0 6px 18px rgba(46,125,50,0.25)",
      borderRadius: "12px",
    }}
  >
    <Card.Body className="py-3 px-3 d-flex align-items-center justify-content-between">
      <div>
        <div
          style={{
            fontSize: "12px",
            fontWeight: 600,
            color: "#2E7D32",
            letterSpacing: "0.5px",
          }}
        >
          FABRIC STOCK
        </div>
        <div
          style={{
            fontSize: "18px",
            fontWeight: 700,
            color: "#1B5E20",
          }}
        >
          {block.stock_qty || 0} <span style={{ fontSize: "14px" }}>mtr</span>
        </div>
      </div>

      <div
        style={{
          background: "#C8E6C9",
          color: "#1B5E20",
          width: "42px",
          height: "42px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
        }}
      >
        <i className="fa-solid fa-layer-group"></i>
      </div>
    </Card.Body>
  </Card>
</Col>

  )}
</Row>



{/* MEASUREMENT TABLE */}
{block.item_id && block.fabric_type && (
  <>
    {block.loading ? (
      <div className="text-muted text-center">Loading measurements...</div>
    ) : block.measurements.length > 0 ? (
      <Table bordered size="sm">
        <thead className="table-light text-center">
          <tr>
            <th>SL</th>
            <th>Item</th>
            <th>Size</th>
            <th>No. of Measurements</th>
            <th>Total Qty</th>
            <th>Fabric Req. (mtr)</th>
          </tr>
        </thead>
        <tbody className="text-center">
          {block.measurements.map((m, idx) => (
            <tr key={idx}>
              <td>{idx + 1}</td>
              <td>{m.item_name}</td>
              <td>{m.size}</td>
              <td>{m.measurement_count}</td>
              <td>{m.total_quantity}</td>
              <td>{m.fabric_requirement}</td> {/* ✅ Updated */}
            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <div className="text-muted text-center">No measurements found</div>
    )}
  </>
)}








  </div>
))}







<Row className="mt-3">
      <Col className="d-flex justify-content-end">
        <Button
          variant="success"
          className="fw-semibold text-white"
          onClick={handleAddMoreItem}
        >
          <i className="fa-solid fa-plus me-2"></i> Add More
        </Button>
      </Col>
    </Row>


          {/* Tentative Return Date */}
          <Form.Group className="mb-2">
            <Form.Label>Tentative Date of Start Returning <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="date"
              value={formData.tentative_return_date}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tentative_return_date: e.target.value,
                })
              }
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="success" onClick={handleSave}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default IssueJobWork;
